import { createMfeTestpageApp } from '@common/testpage/MfeTestpageApp.js';
import { projectConfig } from '@root/projectConfig.js';

declare let IS_DEV: boolean;
const app = createMfeTestpageApp({
  port: projectConfig.port,
  tag: 'tef-coms4cs4p',
  showClientSelect: true,
  isDev: IS_DEV,
  apiEndpoint: 'api-4p',
});
app.mount('body');
